import _ from 'lodash';

export const getUploadCompletion = <T>(
  items: Array<{ state: T }>,
  filterState: T,
): { count: number; percent: number } => {
  const all = items.length;
  if (all === 0) return { count: 0, percent: 0 };

  const amount = items.filter((i) => i.state === filterState).length;
  return {
    count: amount,
    percent: Math.round((amount / all) * 100),
  };
};

const leadingZeroFormatter = new Intl.NumberFormat(undefined, {
  minimumIntegerDigits: 2,
});

export const getDurationDisplay = (time: number | undefined) => {
  if (!time) {
    return '00:00:00';
  }
  const seconds = Math.floor(time % 60);
  const minutes = Math.floor(time / 60) % 60;
  const hours = Math.floor(time / 3600);
  if (hours === 0) {
    return `${leadingZeroFormatter.format(hours)}:${leadingZeroFormatter.format(
      minutes,
    )}:${leadingZeroFormatter.format(seconds)}`;
  }
  return `${leadingZeroFormatter.format(hours)}:${leadingZeroFormatter.format(
    minutes,
  )}:${leadingZeroFormatter.format(seconds)}`;
};

export const getFileNameWihoutExtension = (name: string) => {
  if (!name) return name;
  const divider =
    name.toLowerCase().lastIndexOf('.mp4') > -1
      ? name.toLowerCase().lastIndexOf('.mp4')
      : name.toLowerCase().lastIndexOf('.mov');
  if (divider > -1) return name.substring(0, divider);
  return name;
};
